var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back"},[(_vm.backBtn)?_c('div',{staticClass:"backpage",on:{"click":_vm.backPrevPage}},[_vm._v("返回")]):_vm._e(),_vm._v(" "),_c('el-backtop',{attrs:{"target":"#xtwrap","bottom":60}},[_c('div',{staticClass:"backtop"},[_vm._v("Top")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3289f3bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/layout/Back.vue
// module id = null
// module chunks = 